export const JUMP_TYPE_ENUM = {
    TO_H5CREDITCARD: 'h5creditCard',
    TO_WEB2APP: 'web2app'
};

export const POPUP_ID = {
    POLICY_POPUP: 'policy_popup',
    RETENTION_POPUP: 'retention_popup',
    PASSPORT_POPUP: 'passport_popup'
};
